import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Star } from 'lucide-react';
export function Testimonials() {
  const testimonials = [{
    quote: 'Mi hija de 9 años toca sus canciones favoritas. No para de practicar.',
    name: 'Laura M.',
    age: 'mamá de alumna'
  }, {
    quote: 'En un mes ya coordinaba las dos manos. Me sorprendió lo rápido que avancé.',
    name: 'Mateo R.',
    age: '14 años'
  }, {
    quote: 'Lo compré sin saber si iba a funcionar y fue la mejor decisión. Mi hijo de 11 años aprendió solo, sin que yo tuviera que explicarle nada.',
    name: 'Carlos B.',
    age: 'papá de alumno'
  }];
  return <section className="py-20 bg-navy relative overflow-hidden" data-id="element-244">
      <div className="absolute top-10 right-0 w-72 h-72 bg-gold/10 rounded-full blur-3xl translate-x-1/3 pointer-events-none" data-id="element-245"></div>
      <div className="absolute bottom-10 left-0 w-56 h-56 bg-gold/5 rounded-full blur-3xl -translate-x-1/4 pointer-events-none" data-id="element-246"></div>
      <div className="absolute top-1/2 left-[60%] text-gold/[0.04] text-7xl font-serif select-none pointer-events-none" data-id="element-247">
        ♬
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10" data-id="element-248">
        <FadeIn data-id="element-249">
          <h2 className="text-3xl md:text-4xl font-black text-center text-beige mb-3" data-id="element-250">
            Lo que dicen <span className="text-gold" data-id="element-251">nuestros alumnos</span>
          </h2>
          <p className="text-center text-beige/60 mb-14 text-lg" data-id="element-252">
            Historias de éxito reales
          </p>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-253">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.15} data-id="element-254">
              <div className="bg-navy-light border border-gold/15 p-7 rounded-2xl h-full flex flex-col hover:border-gold/30 transition-all" data-id="element-255">
                <div className="flex gap-1 mb-5" data-id="element-256">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold text-gold" data-id="element-257" />)}
                </div>
                <p className="text-lg text-beige/85 italic mb-6 flex-grow leading-relaxed" data-id="element-258">
                  "{testimonial.quote}"
                </p>
                <div className="border-t border-beige/10 pt-4" data-id="element-259">
                  <p className="font-bold text-beige text-lg" data-id="element-260">
                    {testimonial.name}
                  </p>
                  <p className="text-beige/50 text-sm" data-id="element-261">{testimonial.age}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}